//#region src/build_type.ts
var BuildType = /* @__PURE__ */ function(BuildType) {
	BuildType["ChromeOS"] = "chromeos";
	BuildType["Garcon"] = "garcon";
	BuildType["Gcn"] = "gcn";
	BuildType["CustomCssGcn"] = "custom-css";
	BuildType["CustomCssVitrine"] = "custom-css-vitrine";
	BuildType["Vitrine"] = "vitrine";
	return BuildType;
}(BuildType || {});
//#endregion
export { BuildType };

//# sourceMappingURL=build_type.js.map